import { useState } from "preact/compat"
import { useLocation } from "wouter-preact"
import { CenterColumnContainer } from "../components/LoginScreen.tsx"
import { TeamInvitationsSettings } from "../settings/team_invitations.tsx"
import { Button } from "@/components/ui/button.tsx"
import { SetupProgressBar } from "./SetupProgressBar.tsx"

// Invite other team members during setup (different than the invite page for creating a new brand)
export function InvitesSetup() {
  const [, setLocation] = useLocation()
  const [skipping, setSkipping] = useState(false)

  function handleContinue() {
    setLocation("/setup/complete")
  }

  function handleSkip() {
    setSkipping(true)
    setLocation("/setup/complete")
  }

  return (
    <CenterColumnContainer title="Add User Accounts">
      <div class="space-y-6">
        <SetupProgressBar progress={75} />
        <p class="text-sm text-gray-600">
          Now that your connections are set up, invite team members to collaborate on deductions and accounting tasks.
          You can skip this step and invite them later from Settings.
        </p>

        <TeamInvitationsSettings />

        <div class="flex gap-3 pt-4">
          <Button onClick={handleSkip} variant="outline" className="flex-1" disabled={skipping}>
            Skip for Now
          </Button>
          <Button onClick={handleContinue} className="flex-1" disabled={skipping}>
            Continue
          </Button>
        </div>
      </div>
    </CenterColumnContainer>
  )
}
